import reactlogo from '../assets/logos/react.svg'
import angularlogo from '../assets/logos/angular.svg'
import vuejslogo from '../assets/logos/vuejs.svg'
import nextjslogo from '../assets/logos/nextjs.svg'
import typescriptlogo from '../assets/logos/typescript.svg'
import javascriptlogo from '../assets/logos/javascript.svg'
import nodejslogo from '../assets/logos/nodejs.svg'
import pythonlogo from '../assets/logos/python.svg'
import oraclelogo from '../assets/logos/oracle.svg'
import dotnetlogo from '../assets/logos/dotnet.svg'
import expresslogo from '../assets/logos/express.svg'
import fastapilogo from '../assets/logos/fastapi.svg'
import djangologo from '../assets/logos/django.svg'
import flasklogo from '../assets/logos/flask.svg'
import springbootlogo from '../assets/logos/springboot.svg'
import mongodblogo from '../assets/logos/mongodb.svg'
import postgresqllogo from '../assets/logos/postgresql.svg'
import mysqllogo from '../assets/logos/mysql.svg'
import redislogo from '../assets/logos/redis.svg'
import elasticsearchlogo from '../assets/logos/elasticsearch.svg'
import dynamodblogo from '../assets/logos/amazon.svg'
import awslogo from '../assets/logos/amazon.svg'
import azurelogo from '../assets/logos/azure.svg'
import gcplogo from '../assets/logos/gcp.svg'
import dockerlogo from '../assets/logos/docker.svg'
import kuberneteslogo from '../assets/logos/kubernetes.svg'
import terraformlogo from '../assets/logos/terraform.svg'
import jenkinslogo from '../assets/logos/jenkins.svg'
import githubactionslogo from '../assets/logos/githubactions.svg'
import reactnativelogo from '../assets/logos/reactnative.svg'
import ioniclogo from '../assets/logos/ionic.svg'
import flutterlogo from '../assets/logos/flutter.svg'
import electronlogo from '../assets/logos/electron.svg'
import githublogo from '../assets/logos/github.svg'
import gitlablogo from '../assets/logos/gitlab.svg'
import vercellogo from '../assets/logos/vercel.svg'
import nginxlogo from '../assets/logos/nginx.svg'
import graphqllogo from '../assets/logos/graphql.svg'
import websocketlogo from '../assets/logos/websocket.svg'
import openailogo from '../assets/logos/openai.svg'
import tensorflowlogo from '../assets/logos/tensorflow.svg'
import pytorchlogo from '../assets/logos/pytorch.svg'
import langchainlogo from '../assets/logos/langchain.svg'


// Core metrics
export const METRICS = {
  yearsExperience: '15+',
  startupsLaunched: '30+',
  customSolutions: '150+'
};

// Contact information
export const CONTACT = {
  email: 'jay@great-engineers.com',
  domain: 'great-engineers.com'
};

// Color Palette - Luxurious Purple Elite Theme
export const COLORS = {
  primary: '#4C3362', // Luxurious Purple
  secondary: '#212227', // Dark Charcoal
  accent: '#28D9C3', // Turquoise Accent
  dark: '#1A1B1F', // Deep Black
  light: '#F9FAFB', // Soft White
  gradients: {
    primary: 'from-[#4C3362] via-[#3C284D] to-[#2E2040]',
    secondary: 'from-gray-900 to-slate-800',
    accent: 'from-teal-400 to-cyan-400',
    hero: 'from-violet-50 via-purple-50 to-purple-100',
    dark: 'from-gray-900 to-black'
  }
};

// Technology logos (CDN URLs) - Full Stack Focus
export const TECH_LOGOS = {
  // Frontend
  react: reactlogo,
  angular: angularlogo,
  vue: vuejslogo,
  nextjs: nextjslogo,
  typescript: typescriptlogo,
  javascript: javascriptlogo,

  // Backend
  nodejs: nodejslogo,
  python: pythonlogo,
  java: oraclelogo,
  dotnet: dotnetlogo,
  express: expresslogo,
  fastapi: fastapilogo,
  django: djangologo,
  flask: flasklogo,
  springboot: springbootlogo,

  // Databases
  mongodb: mongodblogo,
  postgresql: postgresqllogo,
  mysql: mysqllogo,
  redis: redislogo,
  elasticsearch: elasticsearchlogo,
  dynamodb: dynamodblogo,

  // Cloud & DevOps
  aws: awslogo,
  azure: azurelogo,
  gcp: gcplogo,
  docker: dockerlogo,
  kubernetes: kuberneteslogo,
  terraform: terraformlogo,
  jenkins: jenkinslogo,
  githubactions: githubactionslogo,

  // Mobile
  reactnative: reactnativelogo,
  ionic: ioniclogo,
  flutter: flutterlogo,

  // Desktop
  electron: electronlogo,

  // Tools & Services
  github: githublogo,
  gitlab: gitlablogo,
  vercel: vercellogo,
  nginx: nginxlogo,
  graphql: graphqllogo,
  websocket: websocketlogo,

  // AI/ML (for AI service)
  openai: openailogo,
  tensorflow: tensorflowlogo,
  pytorch: pytorchlogo,
  langchain: langchainlogo,
};

// Services data - Elite Full Stack Engineering
export const SERVICES = [
  {
    id: 'frontend-developers',
    slug: 'hire-frontend-developers',
    title: 'Frontend Development',
    shortDesc: 'Architecting sophisticated, high-performance user interfaces that define industry standards.',
    description: [
      "Drawing upon 15+ years of elite frontend engineering, we architect mission-critical interfaces spanning progressive web applications to enterprise-grade dashboards. Our mastery extends across React, Angular, and Vue ecosystems, delivering interfaces that establish competitive advantages through superior user experience.",
      "Every solution embodies cutting-edge design paradigms fused with performance engineering, ensuring applications not only exceed aesthetic benchmarks but deliver instantaneous load times and flawless cross-device execution. Our specialization encompasses advanced component architectures, sophisticated state orchestration, and scalable design systems that empower engineering teams. From single-page applications to complex multi-tenant platforms, we deliver frontend solutions that exemplify technical precision and user-centric excellence."
    ],
    technologies: [
      { name: 'React', logo: 'react' },
      { name: 'Angular', logo: 'angular' },
      { name: 'Vue.js', logo: 'vue' },
      { name: 'TypeScript', logo: 'typescript' },
      { name: 'Next.js', logo: 'nextjs' },
      { name: 'Tailwind CSS', logo: 'javascript' }
    ],
    useCases: ['Progressive Web Apps', 'Single Page Applications', 'Enterprise Dashboards', 'E-commerce Platforms'],
    keywords: ['hire frontend developers', 'react developers', 'angular developers', 'vue developers', 'ui/ux development'],
    color: '#633AA0',
    process: [
      {
        title: 'Strategic requirement analysis and architectural planning',
        description: 'We begin with in-depth discovery sessions to understand your business goals, user needs, and technical constraints. Our architects evaluate existing systems, define success metrics, and create a comprehensive technical roadmap aligned with your vision.'
      },
      {
        title: 'Component architecture design and optimization',
        description: 'Our engineers design scalable component hierarchies, establish design systems, and create reusable patterns. We architect state management solutions, define data flow patterns, and build component libraries that accelerate development while maintaining consistency.'
      },
      {
        title: 'Responsive UI implementation with accessibility standards',
        description: 'We implement pixel-perfect, responsive interfaces that work flawlessly across all devices and screen sizes. Every component is built with WCAG 2.1 AA compliance, ensuring accessibility for all users including those with disabilities.'
      },
      {
        title: 'Performance engineering and optimization',
        description: 'Through advanced profiling, code splitting, lazy loading, and asset optimization, we ensure blazing-fast load times. We optimize rendering performance, implement efficient caching strategies, and eliminate performance bottlenecks for a smooth user experience.'
      },
      {
        title: 'Comprehensive testing and production deployment',
        description: 'Our QA process includes unit testing, integration testing, end-to-end testing, and cross-browser verification. We implement CI/CD pipelines, conduct security audits, and ensure smooth production deployments with comprehensive monitoring and rollback capabilities.'
      }
    ],
    relatedProjects: ['chatapp', 'electron-ocr', 'diagram-generator'],
    relatedServices: ['backend-engineers', 'react-developers', 'nodejs-developers']
  },
  {
    id: 'backend-engineers',
    slug: 'hire-backend-engineers',
    title: 'Backend Engineering',
    shortDesc: 'Engineering robust, scalable server architectures that power enterprise-grade applications.',
    description: [
      "We engineer backend infrastructures that process millions of requests with unwavering reliability and peak performance. Across 30+ enterprise launches and 150+ bespoke solutions, our backend expertise spans Node.js, Python, Java, and .NET ecosystems, enabling strategic technology selection aligned with business objectives.",
      "We design distributed microservices architectures, implement zero-trust security frameworks, optimize database performance for sub-millisecond query execution, and architect APIs that exemplify security, documentation excellence, and long-term maintainability. Whether architecting RESTful APIs, real-time WebSocket infrastructures, or complex event-driven systems with message queues and intelligent caching layers, we deliver backend solutions engineered for enterprise scale and operational excellence."
    ],
    technologies: [
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'Python', logo: 'python' },
      { name: 'Java', logo: 'java' },
      { name: '.NET', logo: 'dotnet' },
      { name: 'FastAPI', logo: 'fastapi' },
      { name: 'Express', logo: 'express' }
    ],
    useCases: ['RESTful API Development', 'Microservices Architecture', 'Real-time Systems', 'Database Design'],
    keywords: ['hire backend engineers', 'api development', 'microservices', 'nodejs developers', 'python developers'],
    color: '#28D9C3',
    process: [
      {
        title: 'Enterprise architecture planning and design',
        description: 'We conduct thorough system analysis to design scalable backend architectures. Our architects evaluate microservices vs monolithic approaches, define service boundaries, select optimal technology stacks, and create detailed architecture diagrams with clear component interactions.'
      },
      {
        title: 'Advanced database schema engineering',
        description: 'Our database experts design normalized schemas, optimize indexing strategies, and implement efficient query patterns. We handle complex relationships, define data migration strategies, and ensure data integrity through comprehensive constraint and validation systems.'
      },
      {
        title: 'API development with comprehensive documentation',
        description: 'We build RESTful or GraphQL APIs with intuitive endpoints, consistent response formats, and comprehensive error handling. Every API includes detailed OpenAPI/Swagger documentation, versioning strategies, and example implementations for seamless integration.'
      },
      {
        title: 'Zero-trust security implementation',
        description: 'Security is embedded at every layer with JWT/OAuth authentication, role-based access control, input validation, SQL injection prevention, XSS protection, and data encryption at rest and in transit. We implement security headers, rate limiting, and comprehensive audit logging.'
      },
      {
        title: 'Performance optimization and load testing',
        description: 'Through rigorous load testing and profiling, we identify and eliminate bottlenecks. We implement caching layers, optimize database queries, configure connection pooling, and ensure your system handles peak loads with auto-scaling capabilities and graceful degradation.'
      }
    ],
    relatedProjects: ['chatapp', 'kuberneteshelm', 'aws-textract'],
    relatedServices: ['frontend-developers', 'nodejs-developers', 'api-integration-experts']
  },
  {
    id: 'devops-engineers',
    slug: 'hire-devops-engineers',
    title: 'DevOps Engineering',
    shortDesc: 'Orchestrating automated infrastructure and deployment pipelines for operational excellence.',
    description: [
      "From AWS EKS orchestration to infrastructure-as-code excellence, we automate deployments for systems processing 20+ million daily requests with zero-downtime reliability. Our DevOps mastery encompasses Kubernetes container orchestration, Terraform and Ansible automation, enterprise CI/CD pipelines via Jenkins and GitHub Actions, comprehensive observability through Prometheus and Grafana, and multi-cloud architecture across AWS, Azure, and GCP.",
      "We implement industry-leading practices for security hardening, infinite scalability, and cost optimization, ensuring your infrastructure embodies resilience, automation, and operational simplicity. Whether executing cloud migrations, establishing sophisticated deployment pipelines, or optimizing existing infrastructure, we bring production-hardened expertise to solve your most complex DevOps challenges."
    ],
    technologies: [
      { name: 'Docker', logo: 'docker' },
      { name: 'Kubernetes', logo: 'kubernetes' },
      { name: 'AWS', logo: 'aws' },
      { name: 'Terraform', logo: 'terraform' },
      { name: 'Jenkins', logo: 'jenkins' },
      { name: 'GitHub Actions', logo: 'githubactions' }
    ],
    useCases: ['Container Orchestration', 'Infrastructure as Code', 'CI/CD Automation', 'Cloud Migration'],
    keywords: ['hire devops engineers', 'kubernetes experts', 'aws devops', 'terraform consultants', 'ci/cd pipeline'],
    color: '#212227',
    process: [
      {
        title: 'Infrastructure assessment and strategic planning',
        description: 'We audit existing infrastructure, identify bottlenecks, and design cloud-native architectures. Our DevOps experts create migration strategies, evaluate multi-cloud requirements, and develop comprehensive infrastructure roadmaps aligned with your scaling needs and budget.'
      },
      {
        title: 'Container strategy development and implementation',
        description: 'We containerize applications with Docker, orchestrate with Kubernetes, and implement service mesh architectures. Our approach includes health checks, resource limits, horizontal pod autoscaling, and persistent storage strategies for stateful workloads.'
      },
      {
        title: 'Enterprise CI/CD pipeline architecture',
        description: 'We build automated pipelines with Jenkins, GitHub Actions, or GitLab CI that handle code quality checks, security scanning, automated testing, and progressive deployments. Every pipeline includes rollback strategies, approval gates, and comprehensive logging for full deployment visibility.'
      },
      {
        title: 'Advanced monitoring and observability setup',
        description: 'We implement comprehensive observability with Prometheus, Grafana, ELK Stack, and distributed tracing. Our monitoring includes custom dashboards, intelligent alerting, log aggregation, and performance metrics that provide deep insights into system health and user experience.'
      },
      {
        title: 'Cost optimization and auto-scaling configuration',
        description: 'Through detailed resource analysis and right-sizing strategies, we optimize cloud spend without compromising performance. We configure intelligent auto-scaling policies, implement spot instances where appropriate, and establish cost monitoring dashboards with budget alerts.'
      }
    ],
    relatedProjects: ['kuberneteshelm', 'terraformdevops', 'awsserverless'],
    relatedServices: ['backend-engineers', 'cloud-app-developers', 'kubernetes-helm']
  },
  {
    id: 'mobile-app-development',
    slug: 'outsource-mobile-app-development',
    title: 'Mobile App Development',
    shortDesc: 'Crafting premium cross-platform mobile experiences for iOS and Android ecosystems.',
    description: [
      "We architect cross-platform mobile solutions with Ionic and React Native that deliver native performance and premium user experiences. From NFC hardware integration to offline-first architectures, we deliver mobile applications that operate flawlessly across iOS and Android platforms. Our mobile engineering philosophy emphasizes native feel while maximizing code efficiency across platforms.",
      "Specialized capabilities include seamless device feature integration (camera, GPS, biometric authentication, push notifications), offline-capable architectures with local persistence, performance optimization for 60fps animations, and secure mobile API architectures with advanced authentication flows. Whether building consumer applications, internal enterprise tools, or complex business solutions, we deliver mobile experiences that users embrace and enterprises depend upon for mission-critical operations."
    ],
    technologies: [
      { name: 'React Native', logo: 'reactnative' },
      { name: 'Ionic', logo: 'ionic' },
      { name: 'Flutter', logo: 'flutter' },
      { name: 'TypeScript', logo: 'typescript' },
      { name: 'Node.js', logo: 'nodejs' }
    ],
    useCases: ['Cross-platform Apps', 'Native Hardware Integration', 'Offline-first Mobile', 'Enterprise Mobile Solutions'],
    keywords: ['mobile app development', 'react native developers', 'ionic developers', 'cross-platform apps', 'ios android development'],
    color: '#633AA0',
    process: [
      {
        title: 'Strategic platform selection and architecture',
        description: 'We evaluate React Native, Ionic, and Flutter to determine the optimal cross-platform approach based on your requirements. Our architects design app architectures with offline-first capabilities, efficient state management, and native module integration strategies.'
      },
      {
        title: 'Premium mobile UI/UX engineering',
        description: 'Our designers create intuitive mobile experiences following iOS Human Interface Guidelines and Material Design principles. We implement smooth animations, gesture handling, and responsive layouts that feel native on both platforms while maximizing code sharing.'
      },
      {
        title: 'Native feature integration and optimization',
        description: 'We seamlessly integrate device features including camera, GPS, biometric authentication, push notifications, background tasks, and local storage. Each integration is optimized for performance and battery efficiency while maintaining cross-platform consistency.'
      },
      {
        title: 'App store deployment and compliance',
        description: 'Our team handles the complete submission process for both Apple App Store and Google Play Store. We ensure compliance with all guidelines, prepare marketing materials, configure in-app purchases, and manage version updates and reviews.'
      },
      {
        title: 'Performance engineering and testing',
        description: 'Through profiling and optimization, we achieve 60fps animations and sub-second startup times. We conduct extensive testing across device types, screen sizes, and OS versions, ensuring smooth performance even on older devices with comprehensive crash reporting.'
      }
    ],
    relatedProjects: ['hybridapp', 'chatapp'],
    relatedServices: ['frontend-developers', 'react-developers', 'nodejs-developers']
  },
  {
    id: 'api-integration-experts',
    slug: 'hire-api-integration-experts',
    title: 'API Integration',
    shortDesc: 'Orchestrating seamless system integrations and automated workflows across enterprise platforms.',
    description: [
      "Across hundreds of third-party API integrations, we establish reliable communication channels between disparate enterprise systems. Our integration expertise handles sophisticated authentication protocols, intelligent rate limiting, webhook orchestration, and resilient error recovery mechanisms ensuring dependable, maintainable integrations.",
      "Specialized capabilities encompass payment processor integration (Stripe, PayPal, Razorpay), CRM connectivity (Salesforce, HubSpot), marketing automation platforms, custom middleware for legacy system modernization, and unified API gateway architectures abstracting multiple services. We architect integrations with intelligent retry logic, circuit breaker patterns, and comprehensive monitoring ensuring your systems communicate flawlessly. Whether connecting select services or architecting comprehensive integration platforms, we deliver solutions engineered for enterprise reliability and operational excellence."
    ],
    technologies: [
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'Python', logo: 'python' },
      { name: 'GraphQL', logo: 'graphql' },
      { name: 'REST APIs', logo: 'github' },
      { name: 'WebSockets', logo: 'websocket' }
    ],
    useCases: ['Third-party Integrations', 'Webhook Management', 'API Gateway Setup', 'Data Synchronization'],
    keywords: ['api integration experts', 'third party integration', 'webhook development', 'api consulting', 'system integration'],
    color: '#28D9C3',
    process: [
      {
        title: 'Integration requirements analysis and planning',
        description: 'We analyze your existing systems and third-party service requirements to create a comprehensive integration strategy. Our architects map data flows, define transformation rules, identify authentication requirements, and establish integration priorities based on business value.'
      },
      {
        title: 'API documentation review and strategy',
        description: 'Our engineers conduct thorough analysis of target API documentation, rate limits, authentication methods, and data models. We design integration architectures that handle versioning, deprecation, and API changes gracefully while maintaining system stability.'
      },
      {
        title: 'Advanced authentication implementation',
        description: 'We implement secure authentication flows including OAuth 2.0, API keys, JWT tokens, and webhook verification. Our approach includes secure credential storage, token refresh mechanisms, and multi-environment configuration for seamless development and production workflows.'
      },
      {
        title: 'Resilient error handling and retry logic',
        description: 'We build robust integration layers with exponential backoff retry strategies, circuit breaker patterns, and fallback mechanisms. Our implementations include comprehensive error logging, dead letter queues for failed requests, and intelligent recovery strategies.'
      },
      {
        title: 'Comprehensive monitoring and alerting',
        description: 'We establish monitoring dashboards tracking API response times, error rates, throughput, and quota usage. Custom alerts notify your team of integration failures, rate limit approaches, and performance degradation, ensuring proactive issue resolution.'
      }
    ],
    relatedProjects: ['salesforcedev', 'elasticemailparser', 'grailstalent'],
    relatedServices: ['backend-engineers', 'nodejs-developers', 'cloud-app-developers']
  },
  {
    id: 'cloud-app-developers',
    slug: 'hire-cloud-application-developers',
    title: 'Cloud Application Development',
    shortDesc: 'Architecting serverless, infinitely scalable applications across AWS, Azure, and GCP.',
    description: [
      "We architect cloud-native applications with auto-scaling capabilities and cost efficiency engineered into their foundation. Leveraging serverless functions, managed databases, global CDNs, and cutting-edge cloud services, we build solutions that deliver enterprise reliability at optimized costs. Our cloud engineering approach harnesses AWS, Azure, and Google Cloud Platform capabilities to create solutions handling massive scale without infrastructure burden.",
      "Specialized expertise includes serverless architectures with Lambda and Azure Functions, managed database services (RDS, DynamoDB, CosmosDB), auto-scaling infrastructure adapting to traffic patterns, multi-region deployments ensuring global availability, and comprehensive observability solutions. Whether migrating legacy applications or architecting greenfield cloud-native systems, we deliver solutions exemplifying cloud architecture excellence, security best practices, and cost optimization strategies that perform flawlessly at global scale."
    ],
    technologies: [
      { name: 'AWS', logo: 'aws' },
      { name: 'Azure', logo: 'azure' },
      { name: 'GCP', logo: 'gcp' },
      { name: 'Lambda', logo: 'aws' },
      { name: 'DynamoDB', logo: 'dynamodb' },
      { name: 'Docker', logo: 'docker' }
    ],
    useCases: ['Serverless Applications', 'Cloud Migration', 'Auto-scaling Systems', 'Multi-region Deployment'],
    keywords: ['cloud application developers', 'aws developers', 'azure developers', 'serverless architecture', 'cloud migration'],
    color: '#212227',
    process: [
      {
        title: 'Strategic cloud platform selection',
        description: 'We evaluate AWS, Azure, and GCP based on your specific requirements including compliance needs, existing infrastructure, pricing models, and service availability. Our recommendations consider vendor lock-in, multi-cloud strategies, and long-term scalability requirements.'
      },
      {
        title: 'Cloud-native architecture design',
        description: 'Our architects design distributed systems leveraging managed services, serverless functions, and cloud-native patterns. We implement event-driven architectures, microservices communication, service discovery, and resilient patterns for fault tolerance and high availability.'
      },
      {
        title: 'Serverless implementation and optimization',
        description: 'We build serverless applications using Lambda, Azure Functions, or Cloud Functions with optimized cold start times and efficient resource allocation. Our implementations include function composition, event triggers, and integration with managed databases and message queues.'
      },
      {
        title: 'Security hardening and compliance',
        description: 'We implement IAM policies following least-privilege principles, encrypt data at rest and in transit, configure VPCs and security groups, and ensure compliance with standards like SOC 2, HIPAA, or GDPR. Our security approach includes regular audits and vulnerability scanning.'
      },
      {
        title: 'Cost optimization and resource management',
        description: 'Through tagging strategies, reserved instances, spot instances, and auto-scaling policies, we minimize cloud spending. We establish cost monitoring, implement resource cleanup automation, and provide recommendations for ongoing optimization based on actual usage patterns.'
      }
    ],
    relatedProjects: ['awsserverless', 'aws-textract', 'monitoring'],
    relatedServices: ['devops-engineers', 'backend-engineers', 'kubernetes-helm']
  },
  {
    id: 'react-developers',
    slug: 'hire-react-developers',
    title: 'React Development',
    shortDesc: 'Master-level React engineering for SPAs, dashboards, and enterprise-grade interfaces.',
    description: [
      "React represents our primary frontend discipline, with a portfolio spanning elegant landing pages to sophisticated data visualization dashboards. Our mastery encompasses the complete React ecosystem including Hooks, Context API, Redux, React Query, and Next.js for server-side rendering excellence. Our React engineering emphasizes performant, maintainable applications adhering to contemporary best practices.",
      "Core competencies include reusable component library development, efficient state management patterns, bundle optimization for optimal loading performance, accessible interface engineering for universal usability, and scalable architectural patterns supporting team growth. Whether architecting single-page applications, administrative dashboards, customer portals, or complex data-driven interfaces, we deliver React solutions engineered for velocity, maintainability, and longevity. Our commitment to staying current with React's evolution ensures your applications leverage the most advanced capabilities available."
    ],
    technologies: [
      { name: 'React', logo: 'react' },
      { name: 'Next.js', logo: 'nextjs' },
      { name: 'TypeScript', logo: 'typescript' },
      { name: 'Redux', logo: 'react' },
      { name: 'React Query', logo: 'react' }
    ],
    useCases: ['Single Page Applications', 'Admin Dashboards', 'E-commerce Frontends', 'Real-time Interfaces'],
    keywords: ['hire react developers', 'react js developers', 'nextjs developers', 'react native developers', 'frontend react experts'],
    color: '#633AA0',
    process: [
      {
        title: 'Component architecture strategic planning',
        description: 'We design React component hierarchies emphasizing reusability, composability, and maintainability. Our architects define component boundaries, establish prop interfaces, create folder structures, and implement design systems that scale with your team and product.'
      },
      {
        title: 'Advanced state management implementation',
        description: 'We implement efficient state management using React Hooks, Context API, Redux, or Zustand based on complexity. Our approach includes normalized state structures, optimized selectors, middleware for side effects, and patterns that prevent unnecessary re-renders and improve performance.'
      },
      {
        title: 'Performance optimization and profiling',
        description: 'Through React Profiler and Chrome DevTools, we identify and eliminate performance bottlenecks. We implement code splitting, lazy loading, memoization strategies, virtual scrolling for large lists, and optimize bundle sizes to ensure lightning-fast load times and smooth interactions.'
      },
      {
        title: 'Comprehensive testing and quality assurance',
        description: 'We implement testing strategies with Jest and React Testing Library covering unit tests, integration tests, and component behavior. Our QA includes accessibility testing, visual regression testing, and cross-browser verification to ensure flawless user experiences.'
      },
      {
        title: 'Production deployment and monitoring',
        description: 'We configure optimized production builds with CI/CD pipelines, CDN deployment, and environment-specific configurations. Post-deployment monitoring includes error tracking with Sentry, performance monitoring, user analytics, and real-time alerting for production issues.'
      }
    ],
    relatedProjects: ['chatapp', 'diagram-generator', 'retool-insights-dashboard'],
    relatedServices: ['frontend-developers', 'nodejs-developers', 'mobile-app-development']
  },
  {
    id: 'nodejs-developers',
    slug: 'hire-nodejs-developers',
    title: 'Node.js Development',
    shortDesc: 'High-performance, event-driven server architectures processing millions of requests.',
    description: [
      "Node.js powers our backend engineering, delivering scalable APIs, WebSocket servers, and microservices handling millions of requests with exceptional efficiency. Our expertise spans Express, NestJS, and core Node.js, encompassing every major framework and architectural pattern.",
      "Specialized capabilities include RESTful and GraphQL API development with comprehensive authentication and validation, real-time application engineering with WebSockets and Socket.io, microservices architectures with message queue integration, performance optimization through clustering and intelligent caching strategies, and database integration across MongoDB, PostgreSQL, and Redis. We architect clean, testable Node.js code adhering to industry excellence standards for security, error handling, and horizontal scalability. Whether architecting simple API backends or complex event-driven architectures, we deliver Node.js solutions engineered for robustness, peak performance, and production-grade reliability at enterprise scale."
    ],
    technologies: [
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'Express', logo: 'express' },
      { name: 'TypeScript', logo: 'typescript' },
      { name: 'MongoDB', logo: 'mongodb' },
      { name: 'PostgreSQL', logo: 'postgresql' },
      { name: 'Redis', logo: 'redis' }
    ],
    useCases: ['RESTful APIs', 'Real-time Chat Systems', 'Microservices', 'Stream Processing'],
    keywords: ['hire nodejs developers', 'node js backend', 'express developers', 'javascript backend', 'nodejs microservices'],
    color: '#28D9C3',
    process: [
      {
        title: 'API architecture design and documentation',
        description: 'We design RESTful or GraphQL APIs with clear endpoint structures, consistent naming conventions, and comprehensive OpenAPI documentation. Our architecture includes versioning strategies, response pagination, filtering capabilities, and detailed error codes for intuitive API consumption.'
      },
      {
        title: 'Database integration and optimization',
        description: 'Our engineers integrate MongoDB, PostgreSQL, or Redis with optimized connection pooling, query optimization, and efficient indexing strategies. We implement database migrations, data validation, transaction management, and backup strategies for data integrity and reliability.'
      },
      {
        title: 'Advanced authentication and authorization',
        description: 'We implement secure authentication with JWT tokens, refresh token rotation, OAuth 2.0, and role-based access control (RBAC). Our security layer includes password hashing with bcrypt, rate limiting, CORS configuration, and session management for enterprise-grade security.'
      },
      {
        title: 'Performance tuning and profiling',
        description: 'Through profiling and load testing, we optimize database queries, implement caching with Redis, configure clustering for multi-core utilization, and eliminate memory leaks. We ensure your Node.js application handles thousands of concurrent requests with minimal latency.'
      },
      {
        title: 'Deployment orchestration and monitoring',
        description: 'We configure production deployments with PM2 or containerized environments, implement health checks, graceful shutdown handling, and zero-downtime deployments. Comprehensive monitoring with logging, APM tools, and real-time alerting ensures system reliability and quick issue resolution.'
      }
    ],
    relatedProjects: ['chatapp', 'streaming', 'grailstalent'],
    relatedServices: ['backend-engineers', 'react-developers', 'api-integration-experts']
  },
  {
    id: 'desktop-app-development',
    slug: 'outsource-desktop-app-development',
    title: 'Desktop Application Development',
    shortDesc: 'Premium cross-platform desktop applications for Windows and macOS ecosystems.',
    description: [
      "Leveraging Electron and modern web technologies, we architect desktop applications delivering native experiences on Windows and macOS from unified codebases. From auto-update mechanisms to deep OS integration, we craft professional desktop software meeting native application expectations.",
      "Our desktop engineering expertise encompasses cross-platform development with Electron and React, native feature implementation (system tray, notifications, file system access), secure inter-process communication architectures, automatic update systems for seamless distribution, and performance optimization for desktop environments. Whether developing business productivity tools, developer utilities, content creation applications, or specialized desktop software, we deliver applications operating reliably across platforms with seamless OS integration, exemplifying professional quality and technical excellence that users expect from premium desktop software."
    ],
    technologies: [
      { name: 'Electron', logo: 'electron' },
      { name: 'React', logo: 'react' },
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'TypeScript', logo: 'typescript' }
    ],
    useCases: ['Business Software', 'Developer Tools', 'Content Creation Apps', 'System Utilities'],
    keywords: ['desktop app development', 'electron developers', 'cross-platform desktop', 'windows mac apps', 'desktop software development'],
    color: '#212227',
    process: [
      {
        title: 'Desktop UX design and architecture',
        description: 'We design desktop-optimized user experiences with native menus, keyboard shortcuts, and platform-specific patterns. Our architects plan application structure, main/renderer process separation, IPC communication, and data persistence strategies for optimal desktop performance.'
      },
      {
        title: 'Electron framework setup and optimization',
        description: 'We configure Electron with optimized build settings, security configurations including context isolation, and efficient resource management. Our setup includes development hot-reload, production builds with code signing, and webpack optimization for minimal bundle sizes.'
      },
      {
        title: 'Native OS integration and features',
        description: 'We implement system tray integration, native notifications, file system access, clipboard operations, and deep linking. Platform-specific features include Windows registry integration, macOS Touch Bar support, and custom protocol handlers for seamless OS integration.'
      },
      {
        title: 'Auto-update implementation and testing',
        description: 'We implement automatic update mechanisms using Electron-updater with differential downloads, update notifications, and rollback capabilities. Our testing ensures updates install reliably across platforms with proper version management and release channel support.'
      },
      {
        title: 'Multi-platform packaging and distribution',
        description: 'We configure electron-builder for Windows (NSIS/MSI), macOS (DMG/PKG), and Linux (AppImage/deb) installers. Our distribution includes code signing certificates, notarization for macOS, and automated release pipelines for seamless version deployment.'
      }
    ],
    relatedProjects: ['electron-ocr-app'],
    relatedServices: ['frontend-developers', 'electron-ocr-app', 'nodejs-developers']
  },
  {
    id: 'ai-engineers',
    slug: 'great-ai-engineers',
    title: 'AI Engineering',
    shortDesc: 'Integrating sophisticated AI capabilities into enterprise full-stack applications.',
    description: [
      "While primarily full-stack engineering specialists, we integrate advanced AI capabilities that enhance application functionality and deliver measurable business value. From conversational interfaces and virtual assistants to intelligent document processing and automation, we implement AI features providing tangible ROI.",
      "Our AI integration experience encompasses conversational interface development with OpenAI GPT models and custom training, document intelligence via OCR and natural language processing, recommendation engines and personalization systems, image and video analysis capabilities, and RAG (Retrieval Augmented Generation) architectures for knowledge base applications. We prioritize practical AI implementations solving genuine problems over complexity for its own sake. Whether adding conversational AI to customer service platforms, automating document workflows, or building intelligent features, we deliver AI solutions operating reliably in production environments and providing quantifiable value to users and business stakeholders."
    ],
    technologies: [
      { name: 'OpenAI', logo: 'openai' },
      { name: 'Python', logo: 'python' },
      { name: 'TensorFlow', logo: 'tensorflow' },
      { name: 'LangChain', logo: 'langchain' },
      { name: 'FastAPI', logo: 'fastapi' }
    ],
    useCases: ['Chatbot Integration', 'Document Processing', 'AI-powered Features', 'Recommendation Systems'],
    keywords: ['ai integration', 'machine learning engineers', 'chatbot development', 'ai features', 'intelligent systems'],
    color: '#633AA0',
    process: [
      {
        title: 'AI use case identification and validation',
        description: 'We analyze your business processes to identify high-value AI opportunities. Our consultants evaluate feasibility, data requirements, expected ROI, and user impact. We prioritize use cases that deliver measurable value and align with your strategic objectives.'
      },
      {
        title: 'Model selection or custom training',
        description: 'We evaluate pre-trained models from OpenAI, Anthropic, and open-source alternatives against your requirements. For specialized needs, we fine-tune models or train custom solutions. Our selection considers accuracy, latency, cost, and data privacy requirements.'
      },
      {
        title: 'Enterprise API integration',
        description: 'We integrate AI services with robust error handling, retry logic, and fallback strategies. Our implementations include prompt engineering, context management, streaming responses, and cost optimization through caching and intelligent request batching.'
      },
      {
        title: 'Frontend AI feature implementation',
        description: 'We build intuitive user interfaces for AI features including conversational interfaces, real-time suggestions, and progressive disclosure patterns. Our UX designs manage loading states, handle errors gracefully, and provide transparency about AI capabilities and limitations.'
      },
      {
        title: 'Performance monitoring and optimization',
        description: 'We implement comprehensive monitoring tracking response times, error rates, token usage, and user satisfaction. Our optimization strategies include prompt refinement, response caching, and A/B testing to continuously improve AI feature performance and user experience.'
      }
    ],
    relatedProjects: ['ai-chatbot-fisheries', 'avatar-based-sign-language-ai', 'diagram-generator'],
    relatedServices: ['backend-engineers', 'nodejs-developers', 'ai-chatbot-fisheries']
  }
];

// Case studies with full project details - Full-stack projects at the top
export const CASE_STUDIES = [
  {
    id: 'geo-spatial-app',
    title: 'Geo-Spatial Analytics & User Tracking Platform',
    subtitle: 'Big Data Predictive Analytics',
    description: 'Enterprise-grade big data platform processing 20+ million daily requests, delivering real-time user tracking, predictive analytics, and interactive geospatial visualizations with advanced mapping capabilities.',
    challenge: 'Processing massive volumes of location data in real-time while providing interactive visualizations, predictive insights, and maintaining sub-second response times at unprecedented scale.',
    solution: 'Architected a distributed system leveraging PySpark on AWS EMR for data processing, ElasticSearch with geo-spatial indexing, Node.js with Socket.IO for real-time streaming, and Mapbox for interactive visualizations.',
    results: [
      'Scaled to 20 million requests per day',
      'Real-time map integration at 200 hits/second',
      'Live tracking of 884 data points simultaneously',
      'Processing 84.5M+ augmented data points per hour',
      'Predictive analytics for customer demographics'
    ],
    technologies: [
      { name: 'Python', logo: 'python' },
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'AWS', logo: 'aws' },
      { name: 'ElasticSearch', logo: 'elasticsearch' },
      { name: 'Redis', logo: 'redis' }
    ],
    images: [],
    features: [
      'PySpark on AWS EMR for geospatial clustering',
      'ElasticSearch with geo-spatial indexing',
      'Real-time streaming via Node.js and Socket.IO',
      'Custom shape file and boundary box logic',
      'Predictive models for growth and spending analytics'
    ],
    color: '#633AA0'
  },
  {
    id: 'email-campaign-app',
    title: 'Enterprise Email Campaign Management Platform',
    subtitle: 'Marketing Automation Solution',
    description: 'Comprehensive email marketing platform with drag-and-drop builder, advanced segmentation, A/B testing, and automated workflows. Seamlessly handles high-volume campaigns with AWS SES integration.',
    challenge: 'Creating a Mailchimp-comparable platform capable of handling high email volumes, providing real-time analytics, robust segmentation, and ensuring high deliverability rates with comprehensive compliance.',
    solution: 'Developed full-stack platform using Java/Grails backend with React frontend, integrated AWS SES for scalable email delivery, implemented advanced segmentation, A/B testing, and real-time analytics dashboard.',
    results: [
      'Drag-and-drop email builder with dynamic templates',
      'Advanced segmentation by behavior and demographics',
      'Real-time analytics for open rates and conversions',
      'A/B testing for subject lines and content',
      'GDPR and CAN-SPAM compliant infrastructure'
    ],
    technologies: [
      { name: 'Java', logo: 'java' },
      { name: 'React', logo: 'react' },
      { name: 'AWS', logo: 'aws' },
      { name: 'Bootstrap', logo: 'javascript' }
    ],
    images: [],
    features: [
      'Custom SMTP and AWS SES integration',
      'Dynamic template variables and personalization',
      'Automated workflows and triggered sequences',
      'DKIM, SPF, and DMARC authentication support',
      'Multi-channel integration (SMS, push, social)'
    ],
    color: '#28D9C3'
  },
  {
    id: 'order-management-system',
    title: 'Multi-Channel Order Management System',
    subtitle: 'E-Commerce Integration Platform',
    description: 'Unified SaaS platform for online retailers managing orders across eBay, ePages, Trademe, and custom e-commerce sites. Automates inventory tracking, payment processing, and fulfillment workflows.',
    challenge: 'Retailers manually managing orders across multiple platforms faced inefficiency, inventory discrepancies, and customer communication challenges requiring unified automation.',
    solution: 'Built comprehensive Grails-based platform with email parsing, automatic order synchronization, address verification, BOM reports, and integrated payment gateways on AWS auto-scale infrastructure.',
    results: [
      'Unified management for 8,912+ orders across platforms',
      'Automated inventory synchronization and tracking',
      'Email parsing for order and payment extraction',
      'Address verification with customer email confirmation',
      'Scalable AWS RDS database infrastructure'
    ],
    technologies: [
      { name: 'Java', logo: 'java' },
      { name: 'MySQL', logo: 'mysql' },
      { name: 'AWS', logo: 'aws' },
      { name: 'Spring', logo: 'springboot' }
    ],
    images: [],
    features: [
      'Multi-channel order synchronization (eBay, ePages, Trademe)',
      'Automated stock purchase order creation',
      'BOM (Bill of Materials) structure reports',
      'Payment gateway integration (PayPal, eWay)',
      'CSV export/import for bulk operations'
    ],
    color: '#212227'
  },
  {
    id: 'social-food-habits',
    title: 'Social Food Habits Analytics Platform',
    subtitle: 'Serverless Crowd Aggregation',
    description: 'Highly scalable serverless platform for analyzing social food habits, bringing users together to collaborate and spread awareness about social joints and food outlets with real-time analytics.',
    challenge: 'Building a highly scalable platform for studying food habits with serverless architecture, secure data handling, and real-time analytics while maintaining best CI/CD practices.',
    solution: 'Implemented serverless application using AWS Lambda, DynamoDB, Kinesis for streaming, and ElasticSearch for analytics, deployed via Serverless Framework with CloudFormation validation.',
    results: [
      'Highly scalable serverless architecture',
      'AWS auto-scale cluster for data capture',
      'Real-time data streaming to ElasticSearch',
      'Secure IAM-based ElasticSearch access',
      'Comprehensive CI/CD with Mocha/Chai testing'
    ],
    technologies: [
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'AWS', logo: 'aws' },
      { name: 'ElasticSearch', logo: 'elasticsearch' },
      { name: 'DynamoDB', logo: 'dynamodb' }
    ],
    images: [],
    features: [
      'Serverless Framework deployment',
      'Amazon Kinesis data streaming',
      'Lambda triggers for data processing and indexing',
      'CloudFormation template validation',
      'Secured ElasticSearch with signed requests'
    ],
    color: '#633AA0'
  },
  {
    id: 'supabase-social-sync',
    title: 'Supabase Social Media Platform',
    subtitle: 'Real-Time Social Engagement',
    description: 'Modern social media platform built with Supabase for real-time data management, user authentication, and scalable backend services. Features live updates, content moderation, and seamless user engagement.',
    challenge: 'Creating a secure, scalable social platform with real-time updates, multi-session management, dynamic content moderation, and achieving 99.9% uptime with optimal performance.',
    solution: 'Leveraged Supabase PostgreSQL, Authentication, Real-Time Channels, Edge Functions, and Row-Level Security. Deployed Next.js frontend on Vercel with edge caching and auto-scaling.',
    results: [
      'Improved function execution time by 25%',
      'Achieved 99.9% backend uptime',
      'Seamless authentication across devices',
      'Real-time content updates and notifications',
      'Optimized frontend performance and SEO'
    ],
    technologies: [
      { name: 'React', logo: 'react' },
      { name: 'Next.js', logo: 'nextjs' },
      { name: 'PostgreSQL', logo: 'postgresql' },
      { name: 'Vercel', logo: 'vercel' }
    ],
    images: [],
    features: [
      'Supabase Authentication (email, Google, Facebook)',
      'Real-Time Channels for live updates',
      'Edge Functions for dynamic content moderation',
      'Row-Level Security (RLS) for data protection',
      'Automated email notifications and templates'
    ],
    color: '#28D9C3'
  },
  {
    id: 'ai-chatbot-fisheries',
    title: 'Enterprise AI Chatbot for Fisheries Management',
    subtitle: 'Intelligent Regulatory Compliance System',
    description: 'Next-generation AI-powered conversational system delivering instantaneous, context-aware interactions for ACME Fisheries with advanced document retrieval and real-time response generation capabilities.',
    challenge: 'ACME Fisheries required immediate access to complex regulatory information, significantly reducing repetitive operational workload while maintaining precision and source attribution in responses.',
    solution: 'Architected an intelligent chatbot leveraging FastAPI, FAISS vector database for semantic retrieval, BM25 ranking algorithms, and Hugging Face Zephyr-7B LLM for advanced natural language understanding and generation.',
    results: [
      'Automated fisheries regulation query processing',
      'Real-time document retrieval with source citations',
      'Achieved 60% reduction in personnel workload',
      'Enhanced stakeholder engagement through NLP',
      'Scalable FastAPI microservices architecture'
    ],
    technologies: [
      { name: 'FastAPI', logo: 'fastapi' },
      { name: 'Python', logo: 'python' },
      { name: 'FAISS', logo: 'python' },
      { name: 'Hugging Face', logo: 'python' }
    ],
    images: [],
    features: [
      'Advanced NLP for intelligent query understanding',
      'Vector-based document retrieval via PyPDFLoader and FAISS',
      'Zephyr-7B LLM for contextual response generation',
      'Regulatory compliance and audit trail support',
      'Context-aware multi-turn conversation management'
    ],
    color: '#633AA0'
  },
  {
    id: 'avatar-sign-language',
    title: 'Speech-to-Sign Language Avatar Platform',
    subtitle: 'AI-Powered Accessibility Innovation',
    description: 'Pioneering speech-to-sign language translation platform utilizing deep learning and 3D animated avatars, revolutionizing communication accessibility for the deaf and hard-of-hearing community.',
    challenge: 'Communication barriers facing the deaf community necessitated real-time, precise speech-to-sign translation with visually accurate sign language representation.',
    solution: 'Engineered a sophisticated multi-module pipeline: Bidirectional LSTM with Attention mechanisms for speech recognition, D-Tune BERT for text-to-ISL translation, and photorealistic 3D avatar rendering.',
    results: [
      'Achieved 99.45% validation accuracy with D-Tune BERT',
      'Attained 98.70% accuracy with BILSTM Attention',
      'Real-time speech-to-sign conversion capability',
      'Comprehensive Indian Sign Language (ISL) support',
      'Photorealistic 3D animated avatar output'
    ],
    technologies: [
      { name: 'TensorFlow', logo: 'tensorflow' },
      { name: 'PyTorch', logo: 'pytorch' },
      { name: 'Python', logo: 'python' }
    ],
    images: [],
    features: [
      'MFCC and spectrogram feature extraction',
      'Multiple model architectures (LSTM, BILSTM, BERT)',
      'HamNoSys phonetic notation encoding',
      'SiGML-based avatar animation rendering',
      'Seamless real-time conversion pipeline'
    ],
    color: '#28D9C3'
  },
  {
    id: 'kubernetes-helm',
    title: 'Enterprise Kubernetes Cluster with Helm Orchestration',
    subtitle: 'Production DevOps Infrastructure',
    description: 'Scalable application deployment infrastructure utilizing Helm charts and Kubernetes on AWS EKS with custom VPC architecture and intelligent load balancer configuration.',
    challenge: 'Required automated, infinitely scalable deployment system with custom VPC networking, granular internal/external API access control, and IP range restrictions for security compliance.',
    solution: 'Deployed sophisticated Helm chart orchestration on Amazon EKS cluster with custom VPC architecture, automated deployment workflows, and security-focused network configurations.',
    results: [
      'Fully automated application deployment pipeline',
      'Custom VPC with comprehensive security controls',
      'Intelligent load balancing for internal/external APIs',
      'Granular IP-based access restrictions',
      'Infinitely scalable Kubernetes infrastructure'
    ],
    technologies: [
      { name: 'Kubernetes', logo: 'kubernetes' },
      { name: 'AWS', logo: 'aws' },
      { name: 'Docker', logo: 'docker' }
    ],
    images: [],
    features: [
      'Helm chart automation and orchestration',
      'AWS EKS cluster management and scaling',
      'Custom VPC architecture and configuration',
      'Advanced load balancer setup and routing',
      'Enterprise security and access control'
    ],
    color: '#212227'
  },
  {
    id: 'diagram-generator',
    title: 'AI-Powered Technical Diagram Generator',
    subtitle: 'Developer Productivity Platform',
    description: 'Intelligent automation tool converting natural language descriptions into professional technical diagrams utilizing ChatGPT API integration and advanced PlantUML/Mermaid rendering engines.',
    challenge: 'Technical diagram creation required mastering complex syntax, consuming significant developer time even for experienced engineering teams.',
    solution: 'Architected an intelligent system leveraging ChatGPT API for code generation, supporting PlantUML and Mermaid.js formats, deployed on Vercel infrastructure with Next.js frontend.',
    results: [
      'Natural language diagram creation capability',
      'Multiple export formats (PNG, SVG, PDF)',
      'Support for flowcharts, mind maps, ER diagrams',
      'Real-time preview and collaborative editing',
      'AI-powered intelligent suggestions'
    ],
    technologies: [
      { name: 'Next.js', logo: 'nextjs' },
      { name: 'Python', logo: 'python' },
      { name: 'Flask', logo: 'flask' },
      { name: 'OpenAI', logo: 'openai' }
    ],
    images: [],
    features: [
      'PlantUML and Mermaid.js rendering engines',
      'Customizable layouts and styling options',
      'Software architecture diagram templates',
      'Entity-relationship model generation',
      'Edge network deployment for global performance'
    ],
    color: '#633AA0'
  },
  {
    id: 'electron-ocr-app',
    title: 'Intelligent Desktop OCR Assistant',
    subtitle: 'AI-Powered Desktop Application',
    description: 'Desktop-based intelligent assistant interpreting on-screen campaign data and generating automated optimization insights utilizing Electron framework and local LLM processing.',
    challenge: 'Eliminating API dependencies by enabling direct reading, comprehension, and interpretation of metrics from visible UI elements with real-time analytical capabilities.',
    solution: 'Developed comprehensive solution using Electron, React, and Node.js with integrated OCR and LLM capabilities for visual data extraction and contextual analysis.',
    results: [
      'Automated context detection and intelligent analysis',
      'Real-time insight generation and recommendations',
      'Multi-campaign recognition and comparison',
      'Offline-first AI execution capability',
      'Keyboard-driven command layer interface'
    ],
    technologies: [
      { name: 'Electron', logo: 'electron' },
      { name: 'React', logo: 'react' },
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'Python', logo: 'python' }
    ],
    images: [],
    features: [
      'Local LLM-based reasoning engine',
      'Dynamic prompt construction and optimization',
      'Adaptive context templates',
      'Secure local data persistence',
      'Cross-platform compatibility'
    ],
    color: '#28D9C3'
  },
  {
    id: 'messaging-app',
    title: 'Enterprise Messaging Platform',
    subtitle: 'Team Collaboration Infrastructure',
    description: 'Cross-platform enterprise communication platform delivering Slack-comparable functionality with advanced formatting, attachment management, and comprehensive enterprise features built on React and Node.js.',
    challenge: 'Enterprises required secure, highly customizable messaging infrastructure with sophisticated channel management, direct messaging capabilities, and granular user access control.',
    solution: 'Developed comprehensive messaging platform using React and Node.js featuring channels, direct messaging, presence indicators, and unified mobile/web experiences.',
    results: [
      'Comprehensive channels and direct messaging',
      'Advanced text formatting and rich media support',
      'Secure file sharing and attachment management',
      'Real-time presence indicators',
      'Unified experience across mobile and web platforms',
      'Role-based access control and permissions'
    ],
    technologies: [
      { name: 'React', logo: 'react' },
      { name: 'Node.js', logo: 'nodejs' },
      { name: 'WebSocket', logo: 'websocket' },
      { name: 'MongoDB', logo: 'mongodb' }
    ],
    images: [],
    features: [
      'Direct messaging and channel architectures',
      'Threaded conversation management',
      'End-to-end encryption protocols',
      'Status updates and presence tracking',
      'Cross-platform accessibility'
    ],
    color: '#212227'
  }
];

// Testimonials
export const TESTIMONIALS = [
  {
    quote: "Jay transformed our ambitious product vision into production reality. His full-stack mastery accelerated our timeline by several months.",
    author: 'Michael Thompson',
    role: 'CEO, Technology Firm',
    color: '#633AA0'
  },
  {
    quote: 'From sophisticated frontend architectures to complex DevOps orchestration, Jay delivered end-to-end excellence. The scalability he engineered is remarkable.',
    author: 'Sarah Martinez',
    role: 'CTO, Cloud Services Group',
    color: '#28D9C3'
  },
  {
    quote: "Our platform required comprehensive modernization. Jay's team delivered a cutting-edge, high-performance application that significantly exceeded our expectations.",
    author: 'David Chen',
    role: 'Founder, Software Systems Company',
    color: '#212227'
  }
];

// YouTube videos (placeholder for future content)
export const VIDEOS = [
  {
    id: 'demo1',
    title: 'Full-Stack Engineering Excellence',
    description: 'Experience our comprehensive development process in action.'
  }
];

// Images (placeholder for case studies)
export const IMAGES = {
  hero1: 'https://via.placeholder.com/800x600/633AA0/FFFFFF?text=Full+Stack+Engineering',
  project1: 'https://via.placeholder.com/800x600/28D9C3/FFFFFF?text=React+Application',
  project2: 'https://via.placeholder.com/800x600/212227/FFFFFF?text=Node+Backend',
  project3: 'https://via.placeholder.com/800x600/633AA0/FFFFFF?text=DevOps+Pipeline'
};

// Project gallery (placeholder)
export const PROJECT_GALLERY = [
  { key: 'project1', title: 'Full-Stack Application', project: 'Web Engineering', image: IMAGES.project1 },
  { key: 'project2', title: 'Backend API', project: 'Backend Engineering', image: IMAGES.project2 },
  { key: 'project3', title: 'CI/CD Pipeline', project: 'DevOps Excellence', image: IMAGES.project3 }
];
